import Helper from './Helper';

class ColumnChart {
  constructor(chartMaxHeight) {
    const wrapperSelector = '.ns-chart-boxes';
    const blueSelector = '.ns-box--blue';
    const graySelector = '.ns-box--gray';
    const boxSelector = '.ns-chart-box__box';
    const valSelector = '.ns-chart-box__val';
    const wrapper = [...document.querySelectorAll(wrapperSelector)];
    wrapper.forEach(wrap => {
      const gray = wrap.querySelector(graySelector);
      const blue = wrap.querySelector(blueSelector);
      const grayTxt = gray.querySelector(valSelector).innerText.replace(",", ".").replace("%", "");
      const blueTxt = blue.querySelector(valSelector).innerText.replace(",", ".").replace("%", "");
      const numGray = parseFloat(grayTxt);
      const numBlue = parseFloat(blueTxt);
      const boxGray = gray.querySelector(boxSelector);
      const boxBlue = blue.querySelector(boxSelector);
      let grayHeight = chartMaxHeight;
      let blueHeight = chartMaxHeight;
      if (numGray < 0 || numBlue < 0) {
        let total = 0;
        let invert;
        if (numGray < 0) {
          invert = numGray * -1;
          total = numBlue + invert;
        }
        if (numBlue < 0) {
          invert = numBlue * -1;
          total = numGray + invert;
        }

        grayHeight = chartMaxHeight / total * numGray;

        if (grayHeight < 0) {
          grayHeight = grayHeight * -1;
        }

        blueHeight = chartMaxHeight / total * numBlue;
        if (blueHeight < 0) {
          blueHeight = blueHeight * -1;
        }

        const line = document.createElement('div');
        line.classList.add('ns-chart-boxes__zero');
        
        if (numGray > numBlue) {
          boxGray.style.marginBottom = blueHeight + 'px';
          line.style.top = (10 + grayHeight) + 'px';
        } else {
          boxBlue.style.marginBottom = grayHeight + 'px';
          line.style.top = (10 + blueHeight) + 'px';
        }
        wrap.appendChild(line);

      } else {

        const line = document.createElement('div');
        line.classList.add('ns-chart-boxes__zero');
        line.style.top = (10+chartMaxHeight) + 'px';
        wrap.appendChild(line);

        if (numGray < numBlue) {
          grayHeight = numGray / numBlue * chartMaxHeight;
        } else {
          blueHeight = numBlue / numGray * chartMaxHeight;
        }
      }
      boxGray.style.height = grayHeight + 'px';
      boxBlue.style.height = blueHeight + 'px';
      wrap.classList.add("null");

        if (Helper.isInViewport(wrap)) {
          wrap.classList.remove("null");
          wrap.classList.add("draw");
        }

    });

    window.addEventListener('scroll', function (event) {
      // Check if the media query is true

        wrapper.forEach(element => {
          if (Helper.isInViewport(element)) {
            element.classList.remove("null");
            element.classList.add("draw");
          }
        });

    }, false);

  }
}

export default ColumnChart;
